import { Routing } from '@singularsystems/neo-core';
import * as AuthorisationRoles from '../../Authorisation/Models/Security/Roles'
import * as IdentityRoles from '../../AccessControl/Models/Commands/Security/Roles'
import InviteUsersView from '../../AccessControl/Views/InviteUsers/InviteUsersView';
import UserGroupsView from '../../Authorisation/Views/UserGroupsView';
import AuthorisationView from '../../AccessControl/Views/Authorisation/AuthorisationView';

const UserManagementRoutes: Routing.IMenuRoute = {
    name: "User Management",
    expanded: false,
    exact: true,
    icon: "users-cog",
    allowAnonymous:false,
    role: AuthorisationRoles.UserAccess.Access,
    children: [
        {
            name: "Invite Users",
            path: "/inviteUsers",
            component: InviteUsersView,
            icon: "user-plus",
            role: IdentityRoles.Users.InviteUser,
        },
        {
            name: "User Groups",
            path: "/userGroups",
            component: UserGroupsView,
            icon: "user-friends",
            role: AuthorisationRoles.UserAccess.Access
        },
        {
            name: "User Authorisation",
            path: "/accessControl/authorisation",
            component: AuthorisationView,
            icon: "user-shield",
            role: IdentityRoles.Users.InviteUser && IdentityRoles.Users.UnlockUser
        }
    ]
}

const PureRoutes: Routing.IRoute[] = [
];

export {
    UserManagementRoutes,
    PureRoutes
}